// Set current year in footer
const currentYearElement = document.getElementById('current-year');
if (currentYearElement) {
    currentYearElement.textContent = new Date().getFullYear();
}

// Sticky Navbar Scroll Detection
const mainNav = document.querySelector('.main-nav');
let lastScroll = 0;

function handleScroll() {
    const currentScroll = window.pageYOffset || document.documentElement.scrollTop;
    const scrollThreshold = 100; // Increased threshold to prevent rapid toggling
    
    // Only toggle if we've crossed the threshold significantly
    if (currentScroll > scrollThreshold) {
        // Add scrolled class when scrolled down
        if (!mainNav.classList.contains('scrolled')) {
            mainNav.classList.add('scrolled');
        }
    } else if (currentScroll < scrollThreshold - 20) {
        // Remove scrolled class when at top (with buffer to prevent flickering)
        if (mainNav.classList.contains('scrolled')) {
            mainNav.classList.remove('scrolled');
        }
    }
    
    lastScroll = currentScroll;
}

// Throttle scroll event for better performance
let ticking = false;
window.addEventListener('scroll', () => {
    if (!ticking) {
        window.requestAnimationFrame(() => {
            handleScroll();
            ticking = false;
        });
        ticking = true;
    }
});

// Check initial scroll position
handleScroll();

// Sticky Buy Button for Book Page (Mobile Only)
const stickyBuyButton = document.querySelector('.sticky-buy-button');
const mainFooter = document.querySelector('.main-footer');

if (stickyBuyButton && mainFooter) {
    let lastScrollTop = 0;
    const scrollThreshold = 200; // Show button after scrolling 200px
    
    function handleStickyButton() {
        // Only run on mobile devices
        if (window.innerWidth > 767) {
            stickyBuyButton.classList.remove('visible');
            stickyBuyButton.classList.add('hidden');
            return;
        }
        
        const currentScrollTop = window.pageYOffset || document.documentElement.scrollTop;
        const footerRect = mainFooter.getBoundingClientRect();
        const footerTop = footerRect.top;
        const windowHeight = window.innerHeight;
        
        // Check if footer is visible (top of footer is above bottom of viewport)
        const isFooterVisible = footerTop < windowHeight;
        
        // Check if scrolled past threshold
        const isScrolledEnough = currentScrollTop > scrollThreshold;
        
        // Determine scroll direction
        const scrollingUp = currentScrollTop < lastScrollTop;
        
        // Show button when:
        // 1. Scrolled past threshold AND
        // 2. Footer is NOT visible
        if (isScrolledEnough && !isFooterVisible) {
            stickyBuyButton.classList.remove('hidden');
            stickyBuyButton.classList.add('visible');
        } 
        // Hide button when:
        // 1. Not scrolled enough OR
        // 2. Footer is visible
        else {
            stickyBuyButton.classList.remove('visible');
            stickyBuyButton.classList.add('hidden');
        }
        
        lastScrollTop = currentScrollTop <= 0 ? 0 : currentScrollTop;
    }
    
    // Throttle scroll event for sticky button
    let stickyButtonTicking = false;
    window.addEventListener('scroll', () => {
        if (!stickyButtonTicking) {
            window.requestAnimationFrame(() => {
                handleStickyButton();
                stickyButtonTicking = false;
            });
            stickyButtonTicking = true;
        }
    });
    
    // Handle window resize
    window.addEventListener('resize', () => {
        handleStickyButton();
    });
    
    // Check initial state
    handleStickyButton();
}

// Book Page Image Slider
const sliderTrack = document.querySelector('.slider-track');
const sliderContainer = document.querySelector('.slider-container');
const sliderSlides = document.querySelectorAll('.slider-slide');
const sliderDots = document.querySelectorAll('.slider-dot');
const prevBtn = document.querySelector('.slider-prev');
const nextBtn = document.querySelector('.slider-next');

let currentSlide = 0;
const totalSlides = sliderSlides.length;
let autoplayInterval = null;
let isMobile = window.innerWidth <= 767;

// Check if device is mobile
function checkMobile() {
    isMobile = window.innerWidth <= 767;
    // Stop autoplay if mobile
    if (isMobile && autoplayInterval) {
        clearInterval(autoplayInterval);
        autoplayInterval = null;
    }
}

function updateSlider() {
    if (sliderTrack && sliderSlides.length > 0) {
        sliderTrack.style.transform = `translateX(-${currentSlide * 100}%)`;
        
        // Update dots
        sliderDots.forEach((dot, index) => {
            if (index === currentSlide) {
                dot.classList.add('active');
            } else {
                dot.classList.remove('active');
            }
        });
        
        // Update slides
        sliderSlides.forEach((slide, index) => {
            if (index === currentSlide) {
                slide.classList.add('active');
            } else {
                slide.classList.remove('active');
            }
        });
    }
}

function nextSlide() {
    currentSlide = (currentSlide + 1) % totalSlides;
    updateSlider();
}

function prevSlide() {
    currentSlide = (currentSlide - 1 + totalSlides) % totalSlides;
    updateSlider();
}

// Swipe functionality
let touchStartX = 0;
let touchEndX = 0;
let isDragging = false;
let startX = 0;
let currentX = 0;
let offset = 0;

if (sliderContainer && sliderTrack && sliderSlides.length > 0) {
    // Touch events for mobile
    sliderContainer.addEventListener('touchstart', (e) => {
        touchStartX = e.touches[0].clientX;
        isDragging = true;
        sliderTrack.style.transition = 'none';
    }, { passive: true });

    sliderContainer.addEventListener('touchmove', (e) => {
        if (!isDragging) return;
        touchEndX = e.touches[0].clientX;
        const diff = touchEndX - touchStartX;
        const currentOffset = -currentSlide * 100;
        offset = currentOffset + (diff / sliderContainer.offsetWidth) * 100;
        sliderTrack.style.transform = `translateX(${offset}%)`;
    }, { passive: true });

    sliderContainer.addEventListener('touchend', () => {
        if (!isDragging) return;
        isDragging = false;
        sliderTrack.style.transition = 'transform 0.5s cubic-bezier(0.4, 0, 0.2, 1)';
        
        const diff = touchEndX - touchStartX;
        const threshold = 50; // Minimum swipe distance
        
        if (Math.abs(diff) > threshold) {
            if (diff > 0) {
                // Swipe right - previous slide
                prevSlide();
            } else {
                // Swipe left - next slide
                nextSlide();
            }
        } else {
            // Not enough swipe, return to current slide
            updateSlider();
        }
    }, { passive: true });

    // Mouse events for desktop (drag support)
    sliderContainer.addEventListener('mousedown', (e) => {
        isDragging = true;
        startX = e.clientX;
        sliderTrack.style.transition = 'none';
        sliderContainer.style.cursor = 'grabbing';
    });

    sliderContainer.addEventListener('mousemove', (e) => {
        if (!isDragging) return;
        e.preventDefault();
        currentX = e.clientX;
        const diff = currentX - startX;
        const currentOffset = -currentSlide * 100;
        offset = currentOffset + (diff / sliderContainer.offsetWidth) * 100;
        sliderTrack.style.transform = `translateX(${offset}%)`;
    });

    sliderContainer.addEventListener('mouseup', () => {
        if (!isDragging) return;
        isDragging = false;
        sliderTrack.style.transition = 'transform 0.5s cubic-bezier(0.4, 0, 0.2, 1)';
        sliderContainer.style.cursor = 'grab';
        
        const diff = currentX - startX;
        const threshold = 50;
        
        if (Math.abs(diff) > threshold) {
            if (diff > 0) {
                prevSlide();
            } else {
                nextSlide();
            }
        } else {
            updateSlider();
        }
    });

    sliderContainer.addEventListener('mouseleave', () => {
        if (isDragging) {
            isDragging = false;
            sliderTrack.style.transition = 'transform 0.5s cubic-bezier(0.4, 0, 0.2, 1)';
            sliderContainer.style.cursor = 'grab';
            updateSlider();
        }
    });
}

if (prevBtn && nextBtn && sliderDots.length > 0) {
    // Previous button
    prevBtn.addEventListener('click', () => {
        prevSlide();
    });
    
    // Next button
    nextBtn.addEventListener('click', () => {
        nextSlide();
    });
    
    // Dot navigation
    sliderDots.forEach((dot, index) => {
        dot.addEventListener('click', () => {
            currentSlide = index;
            updateSlider();
        });
    });
    
    // Auto-play slider (desktop only, disabled on mobile)
    function startAutoplay() {
        if (!isMobile && !autoplayInterval) {
            autoplayInterval = setInterval(() => {
                nextSlide();
            }, 5000);
        }
    }
    
    function stopAutoplay() {
        if (autoplayInterval) {
            clearInterval(autoplayInterval);
            autoplayInterval = null;
        }
    }
    
    // Start autoplay on desktop
    startAutoplay();
    
    // Pause autoplay on hover (desktop)
    if (sliderContainer) {
        sliderContainer.addEventListener('mouseenter', () => {
            stopAutoplay();
        });
        
        sliderContainer.addEventListener('mouseleave', () => {
            if (!isMobile) {
                startAutoplay();
            }
        });
    }
    
    // Handle window resize
    window.addEventListener('resize', () => {
        checkMobile();
        if (!isMobile && !autoplayInterval) {
            startAutoplay();
        } else if (isMobile) {
            stopAutoplay();
        }
    });
    
    // Initialize slider
    updateSlider();
}

// Mobile Menu Toggle
const mobileMenuToggle = document.querySelector('.mobile-menu-toggle');
const navMenu = document.querySelector('.nav-menu');
const navMenuOverlay = document.querySelector('.nav-menu-overlay');

function openMenu() {
    if (mobileMenuToggle && navMenu && navMenuOverlay) {
        mobileMenuToggle.setAttribute('aria-expanded', 'true');
        navMenu.classList.add('active');
        navMenuOverlay.classList.add('active');
        document.body.style.overflow = 'hidden';
    }
}

function closeMenu() {
    if (mobileMenuToggle && navMenu && navMenuOverlay) {
        mobileMenuToggle.setAttribute('aria-expanded', 'false');
        navMenu.classList.remove('active');
        navMenuOverlay.classList.remove('active');
        document.body.style.overflow = '';
    }
}

if (mobileMenuToggle && navMenu && navMenuOverlay) {
    // Toggle menu on hamburger click
    mobileMenuToggle.addEventListener('click', (e) => {
        e.stopPropagation();
        const isExpanded = mobileMenuToggle.getAttribute('aria-expanded') === 'true';
        if (isExpanded) {
            closeMenu();
        } else {
            openMenu();
        }
    });

    // Close menu when clicking overlay
    navMenuOverlay.addEventListener('click', (e) => {
        if (e.target === navMenuOverlay) {
            closeMenu();
        }
    });

    // Close menu when clicking on a link
    const navLinks = navMenu.querySelectorAll('.nav-link');
    navLinks.forEach(link => {
        link.addEventListener('click', () => {
            closeMenu();
        });
    });

    // Close menu when clicking close button
    const closeBtn = navMenu.querySelector('.menu-close-btn');
    if (closeBtn) {
        closeBtn.addEventListener('click', () => {
            closeMenu();
        });
    }

    // Close menu on escape key
    document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && navMenu.classList.contains('active')) {
            closeMenu();
        }
    });
}

// Load SVG backgrounds for nav links on hover
function initNavLinkHovers() {
    const navLinks = document.querySelectorAll('.nav-link');
    
    if (navLinks.length === 0) {
        console.warn('No nav links found');
        return;
    }
    
    navLinks.forEach((link, index) => {
        const hoverSvgUrl = link.getAttribute('data-hover-svg-url');
        const hoverBg = link.querySelector('.nav-hover-bg');
        
        if (!hoverBg) {
            console.warn(`Nav hover bg not found for link ${index + 1} (${link.textContent.trim()})`);
            return;
        }
        
        if (!hoverSvgUrl) {
            console.warn(`Hover SVG URL not found for link ${index + 1} (${link.textContent.trim()})`);
            return;
        }
        
        // Use the pre-generated Shopify asset URL from data attribute
        const assetPath = hoverSvgUrl;
        
        // Set the background-image immediately (even if opacity is 0)
        // This ensures the image is loaded and ready
        hoverBg.style.backgroundImage = `url(${assetPath})`;
        hoverBg.style.backgroundSize = 'cover';
        hoverBg.style.backgroundPosition = 'center';
        hoverBg.style.backgroundRepeat = 'no-repeat';
        
        // Preload the SVG to check if it exists
        const img = new Image();
        img.onload = function() {
            // SVG loaded successfully - ensure background is set
            hoverBg.style.backgroundImage = `url(${assetPath})`;
        };
        img.onerror = function() {
            console.warn(`SVG asset not found: ${assetPath} for link ${index + 1} (${link.textContent.trim()})`);
        };
        img.src = assetPath;
        
        // Set background on hover
        link.addEventListener('mouseenter', () => {
            if (hoverBg) {
                hoverBg.style.backgroundImage = `url(${assetPath})`;
                hoverBg.style.opacity = '0.9';
            }
        });
        
        // Reset on mouse leave (optional, for better UX)
        link.addEventListener('mouseleave', () => {
            if (hoverBg && !link.classList.contains('active')) {
                hoverBg.style.opacity = '0';
            }
        });
        
        // Also set for active state
        if (link.classList.contains('active')) {
            hoverBg.style.backgroundImage = `url(${assetPath})`;
            hoverBg.style.opacity = '0.9';
        }
    });
}

// Initialize when DOM is ready
function initializeNavHovers() {
    // Try multiple times in case navigation loads dynamically
    let attempts = 0;
    const maxAttempts = 5;
    
    function tryInit() {
        const navLinks = document.querySelectorAll('.nav-link');
        if (navLinks.length > 0) {
            initNavLinkHovers();
        } else if (attempts < maxAttempts) {
            attempts++;
            setTimeout(tryInit, 200);
        }
    }
    
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => {
            setTimeout(tryInit, 100);
        });
    } else {
        // DOM is already loaded
        setTimeout(tryInit, 100);
    }
}

initializeNavHovers();

// Also re-initialize if navigation is added dynamically (for theme editor)
if (typeof MutationObserver !== 'undefined') {
    const observer = new MutationObserver(() => {
        const navLinks = document.querySelectorAll('.nav-link');
        if (navLinks.length > 0) {
            // Small delay to ensure DOM is fully updated
            setTimeout(initNavLinkHovers, 50);
        }
    });
    
    const navContainer = document.querySelector('.nav-menu');
    if (navContainer) {
        observer.observe(navContainer, {
            childList: true,
            subtree: true
        });
    }
}

// Smooth scroll for anchor links
document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', function (e) {
        e.preventDefault();
        const target = document.querySelector(this.getAttribute('href'));
        if (target) {
            target.scrollIntoView({
                behavior: 'smooth',
                block: 'start'
            });
        }
    });
});

// Add scroll animations
const observerOptions = {
    threshold: 0.1,
    rootMargin: '0px 0px -50px 0px'
};

const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
        if (entry.isIntersecting) {
            entry.target.style.opacity = '1';
            entry.target.style.transform = 'translateY(0)';
            
            // Add special animations for decorative elements
            const decoratives = entry.target.querySelectorAll('.section-decoratives > *');
            if (decoratives.length > 0) {
                decoratives.forEach((el, index) => {
                    setTimeout(() => {
                        el.style.animationPlayState = 'running';
                        // For planes, ensure opacity is visible
                        if (el.classList.contains('section-plane')) {
                            el.style.opacity = '1';
                        } else {
                            el.style.opacity = '';
                        }
                    }, index * 100);
                });
            }
        }
    });
}, observerOptions);

// Observe sections for animation
document.querySelectorAll('section').forEach(section => {
    section.style.opacity = '0';
    section.style.transform = 'translateY(30px)';
    section.style.transition = 'opacity 0.6s ease-out, transform 0.6s ease-out';
    observer.observe(section);
});

// Initialize decorative elements with paused animations
document.querySelectorAll('.section-decoratives > *').forEach(el => {
    // Don't pause planes - they should animate immediately
    if (!el.classList.contains('section-plane')) {
        el.style.animationPlayState = 'paused';
        el.style.opacity = '0';
    } else {
        // Planes should start animating immediately
        el.style.animationPlayState = 'running';
        el.style.opacity = '1';
    }
});

// Parallax effect for decorative elements
window.addEventListener('scroll', () => {
    const scrolled = window.pageYOffset;
    const decorativeElements = document.querySelectorAll('.decorative');
    
    decorativeElements.forEach((element, index) => {
        const speed = 0.5 + (index * 0.1);
        element.style.transform = `translateY(${scrolled * speed}px)`;
    });
});

// Add hover effect to buttons
document.querySelectorAll('.btn').forEach(btn => {
    btn.addEventListener('mouseenter', function() {
        this.style.transform = 'translateY(-3px) scale(1.05)';
    });
    
    btn.addEventListener('mouseleave', function() {
        this.style.transform = 'translateY(0) scale(1)';
    });
});

// Add interactive sparkle effects on image hover
document.querySelectorAll('.about-img-wrapper, .buy-img-wrapper').forEach(wrapper => {
    const img = wrapper.querySelector('img');
    const sparkles = wrapper.querySelectorAll('.img-sparkle');
    
    wrapper.addEventListener('mouseenter', () => {
        sparkles.forEach(sparkle => {
            sparkle.style.animation = 'sparkle 0.5s ease-in-out';
        });
    });
});

// Add bounce effect to Amazon button
const amazonBtn = document.querySelector('.btn-amazon');
if (amazonBtn) {
    amazonBtn.addEventListener('mouseenter', function() {
        const sparkles = this.parentElement.querySelectorAll('.sparkle-dot');
        sparkles.forEach(sparkle => {
            sparkle.style.animation = 'bounceAround 1s ease-in-out';
        });
    });
}

// Contact Form Handler
// Support both Shopify contact form and custom form structure
const contactForm = document.getElementById('contact-form') || document.querySelector('form.contact-form');
if (contactForm) {
    // Handle subject field - add to body for Shopify
    const subjectSelect = contactForm.querySelector('select[name="subject"]');
    const subjectHidden = contactForm.querySelector('input[name="contact[subject]"]');
    const bodyTextarea = contactForm.querySelector('textarea[name="contact[body]"]');
    
    if (subjectSelect && bodyTextarea) {
        // Update hidden subject field when select changes
        subjectSelect.addEventListener('change', function() {
            if (subjectHidden) {
                subjectHidden.value = this.value;
            }
        });
    }
    
    // Allow Shopify form to submit normally, but add visual feedback
    contactForm.addEventListener('submit', function(e) {
        const formData = new FormData(this);
        const name = formData.get('contact[name]') || formData.get('name');
        const email = formData.get('contact[email]') || formData.get('email');
        const subject = formData.get('subject') || formData.get('contact[subject]');
        const message = formData.get('contact[body]') || formData.get('message');
        
        // If subject exists, prepend it to body for Shopify
        if (subject && bodyTextarea && !bodyTextarea.value.includes('Subject:')) {
            const subjectPrefix = subject ? `Subject: ${subject}\n\n` : '';
            bodyTextarea.value = subjectPrefix + (bodyTextarea.value || message || '');
        }
        
        // Show loading state
        const submitBtn = this.querySelector('.btn-submit');
        if (submitBtn) {
            const originalText = submitBtn.textContent;
            submitBtn.textContent = 'Sending...';
            submitBtn.disabled = true;
            
            setTimeout(() => {
                if (submitBtn) {
                    submitBtn.textContent = originalText;
                    submitBtn.disabled = false;
                }
            }, 5000);
        }
        // Shopify will handle the form submission and show success/error messages
    });
}

